// Points as the website shows them (docs/school-carnivals-points-slice-3.md in the portal repo): shared
// ties can give a half or a third, so a value shows at most two decimals, with no trailing zeros:
// 12, 12.5, 3.33. Nothing to show ('' , null or undefined) shows nothing.
export const formatPoints = (value) => {
  if (value === null || value === undefined || value === '') return '';
  const number = Number(value);
  if (!Number.isFinite(number)) return String(value);
  return String(Math.round(number * 100) / 100);
};
